import Rest from '../rest'

/******************************************************************************
 *  Idles
 *****************************************************************************/

/**
 * @type {Idle}
 */
export default class Idle extends Rest {

    constructor () {
        super('/idle')
    }

    /**
     * Retorna as regras de ociosidade de acordo com o ID de uma etapa
     *
     * @param {String|Number} stageId ID da etapa desejada
     * @returns 
     */
    getByStage(stageId) {
        return this.getAllV2(this.constructor.normalize('stage', stageId))
    }
}